<template>
  <div class="compare-container">
    <div class="img">
      <img src="@/assets/pc/images/channel/3.png" alt="" />
    </div>
    <div class="content">
      <table border="0" cellspacing="2" cellpadding="0">
        <tbody>
          <tr>
            <td colspan="7" class="color1" style="font-size:22px;">
              药物具有什么区别
            </td>
          </tr>
          <tr>
            <td class="color1">&nbsp;</td>
            <td colspan="5" class="color2">
              <strong>抗病毒核苷（酸）类药物</strong>
            </td>
            <td class="color1"><strong>干扰素类</strong></td>
          </tr>
          <tr>
            <td class="color1">&nbsp;</td>
            <td class="color2">1、替诺福韦（TDF）</td>
            <td class="color1">2、恩替卡韦（ETV）</td>
            <td class="color2">3、替比夫定（LdT）</td>
            <td class="color1">4、阿德福韦酯（ADV）</td>
            <td class="color2">5、拉米夫定（LAM）</td>
            <td class="color1">重组人干扰素α2b注射液)&nbsp;</td>
          </tr>
          <tr>
            <td class="color1"><strong>代表品种</strong></td>
            <td class="color2">韦瑞德等</td>
            <td class="color1">博路定、雷易得、润众、和恩、恩甘定等</td>
            <td class="color2">素比伏等</td>
            <td class="color1">阿甘定、代丁、爱路韦、名正等</td>
            <td class="color2">贺普丁、贺甘定、银丁</td>
            <td class="color1">凯因益生、利分能、赛若金</td>
          </tr>
          <tr>
            <td class="color1"><strong>适应症</strong></td>
            <td class="color2">1、HIV-1感染<br />2、慢性乙型肝炎</td>
            <td class="color1">
              病毒复制活跃，血清丙氨酸氨基转移酶ALT持续升高或肝脏组织学显示有活动性病变的慢性成人乙肝的治疗。
            </td>
            <td class="color2" style="text-align:left;">
              用于有病毒复制证据以及有血清转氨酶（ALT或AST）持续升高或肝组织活动性病变证据的慢性乙型肝炎成人患者。<br />本适应症基于HBeAg阳性和HBeAg阴性的代偿性慢性乙型肝炎成年患者治疗1年后的病毒学、血清学、生化和组织学应答的结果。
            </td>
            <td class="color1">
              用于治疗乙型肝炎病毒活动复制和血清氨基酸转移酶持续升高的肝功能代偿的成年慢性乙型肝炎患者。
            </td>
            <td class="color2">
              伴有丙氨酸氨基转移酶[ALT]升高和病毒活动复制的、肝功能代偿的成年慢性乙型肝炎病人的治疗。
            </td>
            <td class="color1">
              1、适合治疗某些病毒性疾病，如急慢性病毒性肝炎、带状疱疹、尖锐湿疣。
              2.
              用于治疗某些肿瘤，如毛细胞性白血病、慢性髓细胞白血病、多发性骨髓瘤、非何杰金氏淋巴瘤、恶性黑色素瘤、肾细胞癌、喉乳头状瘤、卡波氏肉瘤、卵巢癌、基底细胞癌、表面膀胱癌等。
            </td>
          </tr>
          <tr>
            <td class="color1"><strong>规格</strong></td>
            <td class="color2">300mg/片</td>
            <td class="color1">0.5mg/片、1mg/片</td>
            <td class="color2">600mg/片</td>
            <td class="color1">10mg/片</td>
            <td class="color2">100mg/片</td>
            <td class="color1">
              0.5ml:500万IU、1ml:300万IU、1ml：500IU、0.3ml:300IU
            </td>
          </tr>
          <tr>
            <td class="color1"><strong>剂型</strong></td>
            <td class="color2">片剂</td>
            <td class="color1">片剂、分散片剂、胶囊剂</td>
            <td class="color2">片剂</td>
            <td class="color1">片剂、胶囊剂</td>
            <td class="color2">片剂</td>
            <td class="color1">注射液</td>
          </tr>
          <tr>
            <td class="color1"><strong>孕妇能否使用</strong></td>
            <td class="color2">孕娠B级，可以在医生的指导下使用</td>
            <td class="color1">&nbsp;</td>
            <td class="color2">孕娠B级，可以在医生的指导下使用</td>
            <td class="color1">&nbsp;</td>
            <td class="color2">&nbsp;</td>
            <td class="color1">&nbsp;</td>
          </tr>
          <tr>
            <td class="color1"><strong>用法用量</strong></td>
            <td class="color2">
              成人和12岁及12岁以上儿童患者（35
              kg或以上）推荐剂量：对HIV-1或慢性乙肝的治疗：剂量为每次300
              mg（1片），每日1次，口服，空腹或与食物同时服用。
            </td>
            <td class="color1">
              成人和16岁以上青年口服本品，每天一次，每次0.5mg。拉米夫定治疗时病毒血症或出现拉米夫定耐药突变的患者为每天一次，每次1.0mg(0.5mg
              两片)。本品应空腹服用（餐前或餐后至少2小时）。
            </td>
            <td class="color2">
              成人和青少年（≥16岁）本品治疗慢性乙型肝炎的推荐剂量为600
              mg，每天一次，口服，餐前或餐后均可，不受进食影响。
            </td>
            <td class="color1">
              成人（18～65岁）本品的推荐剂量为每日1次，每次10mg，饭前或饭后口服均可。
            </td>
            <td class="color2">
              推荐剂量为每日1次，每次100mg，饭前或饭后服用均可。
            </td>
            <td class="color1">
              本品可以肌肉注射、皮下注射和病灶内注射。 1.
              慢性乙型肝炎：皮下或肌肉注射，300～600万IU/日，连用4周后改为3次/周，连用16周以上。医生可根据患者的具体情况而调整剂量。
              2.
              急慢性丙型肝炎：皮下或肌肉注射，300～600万IU/日，连用4周后改为3次/周，连用16周以上。医生可根据患者的具体情况而调整剂量。
              3.
              带状疱疹：肌内注射，100万IU/日，连用6天，同时口服无环鸟苷。医生可根据患者的具体情况而调整剂量。
              4.
              尖锐湿疣：可单独应用，肌内注射，100～300万IU/日，连用四周。也可与激光或电灼等合用，一般采用疣体基底部注射，100万IU/次。
              5.
              毛细胞白血病：200～800万IU/m2/天，连用至少3个月。医生可根据患者具体情况而调整剂量。通常经过1-2个月的治疗后表现出疗效，其后可进行间歇治疗，使病情长期缓解。
              6.
              慢性粒细胞白血病：300～500万IU/m2/天，肌内注射，可与化疗药物羟基脲，Ara-c等合用。血象缓解后可进行维持治疗，隔日注射一次，9-10个月后细胞遗传学指标可有缓解。医生可根据患者的具体情况而调整剂量或联合用药。
              7.
              多发性骨髓瘤：作为诱导或维持治疗，300～500万/m2，肌内注射，3次/周，并与VMCP等化疗方案合用。医生可根据患者的具体情况而调整剂量或联合用药。
              8. 恶性黑色素瘤：每次600万IU，肌内注射，每周三次，与化疗药物合用。
              9.
              非何杰金氏淋巴瘤：作为诱导或维持治疗，剂量为300-500万IU/m2，肌内注射，每周三次，并与CHVP等化疗方案合用。根据不同患者的耐受性，酌情将剂量逐周增加至最大耐受量，8-12周为一个疗程。若未出现病情加剧或严重的不耐受反应，这一剂量应持续治疗至少12个月。医生可根据患者具体情况而调整剂量。
              10.肾细胞癌：600万IU，肌内注射，3次/周，与化疗药物合用。
              11.艾滋病相关性卡波济氏肉瘤：5000万IU/m2/天，连续5天，每次静脉滴注30分钟。至少间隔9天再进行下一个5天的治疗期。
              12.基底细胞癌：500万IU，瘤灶内注射，3次/周，3周。 13.
              卵巢癌：500～800万IU，肌内注射，3次/周，与化疗药物合用。
            </td>
          </tr>
          <tr>
            <td class="color1"><strong>不良反应</strong></td>
            <td class="color2">
              1、全身无力2、胃肠道反应：轻至中度的胃肠道不适，常见的有腹泻、腹痛、食欲减退、恶心、呕吐和胃肠胀气、胰腺炎3、代谢系统：低磷酸盐血症（1%发生率）；脂肪蓄积和重新分布，包括向心性肥胖、水牛背、末梢消瘦、乳房增大、库兴综合征4、可能引起乳酸中毒、与脂肪变性相关的肝肿大等；5、神经系统：头晕、头痛6、呼吸系统：呼吸困难7、皮肤：药疹
            </td>
            <td class="color1">最常见的不良反应有：头痛、疲劳、眩晕、恶心。</td>
            <td class="color2">
              国外临床研究中常见不良反应为虚弱、头痛、腹痛、恶心、（胃肠）气胀、腹泻和消化不良。
            </td>
            <td class="color1">
              国外临床研究中常见不良反应为虚弱、头痛、腹痛、恶心、（胃肠）气胀、腹泻和消化不良。国内临床研究中不良反应为白细胞减少（轻度）、腹泻（轻度）和脱发（中度）。
            </td>
            <td class="color2">
              最常见的不良事件为不适和乏力，呼吸道感染、头痛、腹部不适和腹痛、恶心、呕吐和腹泻。
            </td>
            <td class="color1">
              最常见的不良反应是发热、寒颤、乏力、头痛、肌肉酸痛、厌食等类似流感样症状，加服解热镇痛药（扑热息痛等）可以减轻或消除这些症状，这些症状也可以随着继续用药或调整剂量而减缓。
            </td>
          </tr>
          <tr>
            <td class="color1"><strong>禁忌症</strong></td>
            <td class="color2">
              富马酸替诺福韦二吡呋酯禁用于先前对本药物中任何一种成份过敏的患者。
            </td>
            <td class="color1">对恩替卡韦或制剂中任何成分过敏者禁用。</td>
            <td class="color2">
              素比伏禁止用于已证实对替比夫定及素比伏的其他任何成分过敏的病人。
            </td>
            <td class="color1">
              阿德福韦酯禁止用于已证实对本品的任何组分过敏的病人。&nbsp;
            </td>
            <td class="color2">对拉米夫定或制剂中其他任何成份过敏者禁用。</td>
            <td class="color1">
              对重组人干扰素α2b或该制剂的任何成份有过敏患者禁用。患有严重的心脏疾病者、严重的肝、肾或骨髓功能不正常者、癫痫及中枢神经系统功能损伤者、串有其他严重疾病不能耐受本大副作用者不宜使用。
            </td>
          </tr>
          <tr>
            <td width="107" class="color1"><strong>耐药处理</strong></td>
            <td width="200" class="color2">&nbsp;</td>
            <td width="130" class="color1">换用TDF，或加用ADV</td>
            <td width="130" class="color2">换用TDF，或加用ADV</td>
            <td width="130" class="color1">
              ADV 耐药，之前未使用LAM 换用ETV，或TDF，治疗LAM/LdT
              耐药时出现对ADV 耐药换用TDF，或ETV + ADV
            </td>
            <td width="130" class="color2">换用TDF ，或加用ADV</td>
            <td class="color1">&nbsp;</td>
          </tr>
          <tr>
            <td class="color1"><strong>资料来源</strong></td>
            <td colspan="6" class="color1">
              药品说明书慢性乙肝防治指南-2015版（期刊版-中国肝脏病杂志）
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiverDiseaseCompare"
};
</script>

<style lang="stylus" scoped>
.compare-container
  background #fff
  padding-top 10px
  padding-bottom 20px
  .img
    width 1200px
    margin 0 auto
    img
      width 100%
      height 100%
  .content
    margin-top 20px
    table
      width 1200px
      margin 0 auto
      box-sizing border-box
      td
        line-height 30px
        text-align center
        padding 5px
        font-family 'Microsoft yahei'
        font-size 16px
        color #333
        border 2px solid #fff
      .color1
        background #cedfb3
      .color2
        background #dce8d0
</style>
